import { render } from "./sketch.vue?vue&type=template&id=772d577a"
import script from "./sketch.vue?vue&type=script&lang=js"
export * from "./sketch.vue?vue&type=script&lang=js"

import "./sketch.vue?vue&type=style&index=0&id=772d577a&lang=css"
script.render = render

export default script